interface TastingDetailCTAProps {
  experienceBookingUrl?: string | null;
  venueBookingUrl?: string | null;
  venueWebsite?: string | null;
  venuePhone?: string | null;
  venueId: string;
  venueName: string;
}

export const TastingDetailCTA = ({
  experienceBookingUrl,
  venueBookingUrl,
  venueWebsite,
  venuePhone,
  venueId,
  venueName,
}: TastingDetailCTAProps) => {
  const bookingUrl = experienceBookingUrl || venueBookingUrl;

  if (bookingUrl) {
    return (
      <a
        href={bookingUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center justify-center px-6 py-3 rounded-md bg-primary-700 text-white text-base font-sans tracking-wide hover:bg-primary-800 transition-colors"
      >
        Reserve at {venueName}
      </a>
    );
  }

  if (venueWebsite) {
    return (
      <a
        href={venueWebsite}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center justify-center px-6 py-3 rounded-md bg-primary-700 text-white text-base font-sans tracking-wide hover:bg-primary-800 transition-colors"
      >
        Visit {venueName}
      </a>
    );
  }

  if (venuePhone) {
    return (
      <a
        href={`tel:${venuePhone.replace(/\s/g, '')}`}
        className="inline-flex items-center justify-center px-6 py-3 rounded-md bg-primary-700 text-white text-base font-sans tracking-wide hover:bg-primary-800 transition-colors"
      >
        Call {venuePhone}
      </a>
    );
  }

  return (
    <a
      href={`/wineries/${venueId}`}
      className="inline-flex items-center justify-center px-6 py-3 rounded-md border border-primary-700 text-primary-700 text-base font-sans tracking-wide hover:bg-primary-50 transition-colors"
    >
      View winery details
    </a>
  );
};
